import { useState, useCallback } from 'react';

const VALIDATORS = {
  name: (v) => (v.trim() ? '' : 'Please enter your name'),
  email: (v) => (/^\S+@\S+\.\S+$/.test(v) ? '' : 'Enter a valid email'),
  phone: (v) => (/^\+?\d[\d\s-]{7,}$/.test(v) ? '' : 'Enter a valid phone'),
};

const INITIAL = { name: '', email: '', phone: '', course: 'B.Pharm', message: '' };

export function useEnquiryForm(onSuccess) {
  const [form, setForm] = useState(INITIAL);
  const [errors, setErrors] = useState({});

  const setField = useCallback((field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  }, []);

  const validate = useCallback(() => {
    const next = {};
    Object.keys(VALIDATORS).forEach((key) => {
      const msg = VALIDATORS[key](form[key] || '');
      if (msg) next[key] = msg;
    });
    setErrors(next);
    return Object.keys(next).length === 0;
  }, [form]);

  const submit = useCallback((ev) => {
    ev.preventDefault();
    if (!validate()) return;
    const list = JSON.parse(localStorage.getItem('pca_enquiries') || '[]');
    list.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem('pca_enquiries', JSON.stringify(list));
    setForm(INITIAL);
    setErrors({});
    if (onSuccess) onSuccess();
  }, [form, validate, onSuccess]);

  return { form, errors, setField, submit };
}
